// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sett[data-v-6ea89d17] {\n  position: relative;\n  margin-top: 0.5rem;\n  display: flex;\n  height: 8rem;\n  width: 8rem;\n  flex-direction: column;\n  align-items: flex-start;\n  border-radius: 0.5rem;\n  border-width: 1px;\n  --tw-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));\n}\n", ""]);
// Exports
module.exports = exports;
